import { cpds_brand_colors } from '../../shared/common/colour.token';

export const color = {
  'cpds_primary' : '#FDDB32', //'#191E3B',
  'cpds_secondary' : '#191E3B', //'#FDDB32',
  'cpds_tertiary' : '#FBF8F1',
   // Expedia primary color codes _ Lemon color codes in Design
   'primary_900' : '#333205',
   'primary_800' : '#66650A',
   'primary_700' : '#99970F',
   'primary_600' : '#CBB918',
   'primary_500' : '#FDDB32',
   'primary_400' : '#FEE430',
   'primary_300' : '#FEED63',
   'primary_200' : '#FFF673',
   'primary_100' : '#FFFFA6',
   // Expedia secondary color codes _ Neutral color codes in Design
   'secondary_900': '#0C0E1C',
   'secondary_800': '#191E3B',
   'secondary_700': '#31374F',
   'secondary_600': '#4d5167',
   'secondary_500': '#676A7D',
   'secondary_400': '#9CA0B0',
   'secondary_300': '#D1D5E2',
   'secondary_200': '#E2E4EC',
   'secondary_100': '#F5F5F5',
   'secondary_0': '#FFFFFF',
   // Expedia tertiary color codes _ Cream color codes in Design
   'tertiary_900': '#C0A569',
   'tertiary_800': '#C9B17C',
   'tertiary_700': '#D1BF97',
   'tertiary_600': '#DBCEB1',
   'tertiary_500': '#E4DAC4',
   'tertiary_400': '#EBE4D5',
   'tertiary_300': '#F0EBDF',
   'tertiary_200': '#F5F2EB',
   'tertiary_100': '#FBF8F1',
   common: cpds_brand_colors
}